import Select from 'react-select';
import { StartDate, EndDate,PaymentDue,FollowUpDate ,CreatedDate,PaymentDueFinance,CreatedOnDate, ReconcilitionStartDate, ReconcilitionEndDate } from '../../component/DatePicker';
import MultiSelect from '../../common/MultiSelect';
import {MANAGER_LEVEL_IDS} from '../../config/constant';

export const renderFilterField = (filter: any, props: any) => {
  const { selectedFilters, handleChange, translations,authUserInfo,CustomValueContainer } = props;
  const getOptions = (optionsKey: string) => {
    const options = props.options?.[optionsKey];
    return Array.isArray(options) ? options : [];
  };

  if (filter.roleRestricted && !MANAGER_LEVEL_IDS.includes(authUserInfo?.user_data?.assigned_role_ids)) {
    return null;
  }

  if (filter.dependsOn && !props[filter.dependsOn]) {
    return null;
  }

  if (filter.showWhen) {
    const dependentValue = selectedFilters?.[filter.showWhen.key];
    const shouldShow = filter.showWhen.value === '__ANY__' ? Boolean(dependentValue) : dependentValue === filter.showWhen.value;
    if (!shouldShow) {
      if (selectedFilters?.[filter.key]) {
        handleChange(null, filter.key);
      }
      return null;
    }
  }

  switch (filter.type) {
    case 'search':
      return (
        <fieldset className="search-bx" key={filter.key}>
          <div className="material">
            <input
              type="text"
              name="search"
              className="form-input"
              title={filter.placeholder || translations.commonMsg?.loading}
              aria-label="Policy No/Insurance ID"
              placeholder={filter.placeholder || translations.commonMsg?.loading}
              value={selectedFilters?.[filter.key] || ''}
              onChange={(e) => handleChange(e, filter.key)}
            />
            <i className="ic-search"></i>
          </div>
        </fieldset>
      );

    case 'startDate':
      return (
        <fieldset className="date-filed" key={filter.key}>
          <div className="material">
            <StartDate
              placeholder={filter.placeholder}
              selectedFilters={selectedFilters}
              handleChange={handleChange}
            />
          </div>
        </fieldset>
      );

    case 'endDate':
      return (
        <fieldset className="date-filed" key={filter.key}>
          <div className="material">
            <EndDate
              selectedFilters={selectedFilters}
              handleChange={handleChange}
            />
          </div>
        </fieldset>
      );

    case 'multiSelect':
      const multiSelect_options = getOptions(filter.optionsKey);
      return (
        <fieldset className="single-select mulitselect-opt" key={filter.key}>
          <div className="material">
              <MultiSelect
                isSelectAll={true}
                options={multiSelect_options}
                placeholder={filter.placeholder || translations.commonMsg?.loading}
                value={
                    Array.isArray(selectedFilters?.[filter.key])
                      ? multiSelect_options.filter((option: any) =>
                          selectedFilters[filter.key].includes(option.value)
                        )
                      : []
                }
                onChange={(e: any) => handleChange(e, filter.key)}
                className="react-select"
                classNamePrefix="react-select"
              />
          </div>
        </fieldset>
      );

    case 'select':
      const select_options = getOptions(filter.optionsKey);
      return (
        <fieldset className={`single-select ${filter.className ?? ''}`.trim()} key={filter.key} >
          <div className="material">
            <Select
              components={
                filter.useCustomValueContainer
                  ? { ValueContainer: CustomValueContainer }
                  : undefined
              }
              options={select_options}
              placeholder={filter.placeholder}
              className="react-select"
              classNamePrefix="react-select"
              isClearable
              value={
                select_options.find(
                  (opt: any) => opt.value === selectedFilters?.[filter.key]
                ) || null
              }
              onChange={(e: any) => handleChange(e, filter.key)}
            />
          </div>
        </fieldset>
      );

    case 'paymentDue':
      return (
        <fieldset className="date-filed" key={filter.key}>
          <div className="material">
            <PaymentDue selectedFilters={selectedFilters} handleChange={handleChange} />
          </div>
        </fieldset>
      );

    case 'createdDate':
      return (
        <fieldset className="p-lg-b dateShowField" key={filter.key}>
          <div className="material">
            <CreatedDate selectedFilters={selectedFilters} handleChange={handleChange} />
          </div>
        </fieldset>
      );
      
    case 'followUpDate':
      return (
        <fieldset className="p-lg-b" key={filter.key}>
          <div className="material">
            <FollowUpDate selectedFilters={selectedFilters} handleChange={handleChange} />
          </div>
        </fieldset>
      );

    case 'paymentDueFinance':
      return (
        <fieldset className="date-filed" key={filter.key}>
          <div className="material">
            <PaymentDueFinance selectedFilters={selectedFilters} handleChange={handleChange} />
          </div>
        </fieldset>
      );

    case 'createdOnDate':
      return (
        <fieldset className="date-filed" key={filter.key}>
          <div className="material">
            <CreatedOnDate selectedFilters={selectedFilters} handleChange={handleChange} />
          </div>
        </fieldset>
      );

    case 'reconciliationStartDate':
      return (
        <fieldset className="date-filed" key={filter.key}>
          <div className="material">
            <ReconcilitionStartDate selectedFilters={selectedFilters} handleChange={handleChange} placeholder={filter.placeholder}/>
          </div>
        </fieldset>
      );

    case 'reconciliationEndDate':
        return (
          <fieldset className="date-filed" key={filter.key}>
            <div className="material">
              <ReconcilitionEndDate selectedFilters={selectedFilters} handleChange={handleChange} placeholder={filter.placeholder}/>
            </div>
          </fieldset>
        );

    default:
      return null;
  }
};
